var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25193 4.17207C9.20423 4.85704 10.3705 5.26008 11.63 5.26008V3.33957C10.9269 3.1889 10.3045 2.81904 9.83647 2.30464C9.03544 1.80154 8.45827 0.971498 8.28905 0H6.52317V9.74482C6.51918 10.8809 5.60315 11.8007 4.47359 11.8007C3.80791 11.8007 3.21653 11.4814 2.84203 10.9866C2.17322 10.6469 1.71462 9.94948 1.71462 9.1439C1.71462 8.00466 2.63212 7.08106 3.76416 7.08106C3.98102 7.08106 4.19005 7.11507 4.38616 7.17766V5.23626C1.95514 5.28677 0 7.28605 0 9.74486C0 10.9722 0.4869 12.085 1.27704 12.898C1.98994 13.3797 2.84811 13.6607 3.77137 13.6607C6.24587 13.6607 8.25188 11.6416 8.25188 9.15102V4.17207H8.25193Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.bac44165.svg";
export { ForwardRef as ReactComponent };